import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { QuestionDialog } from 'src/components/widgets/dialog';
import { backofficeUrl, stringFormat, T } from 'src/shared/helpers';

export interface ProductToCategorize {
    id: string;
    name: string;
    code: string;
    image: string;
}

interface CategorizeProductsDialogProps {
    products: ProductToCategorize[];
    onClose: () => void;
}

export const CategorizeProductsDialog: FC<CategorizeProductsDialogProps> = ({ products, onClose }) => {
    const navigate = useNavigate();
    const message =
        products.length === 1
            ? T._('Do you want to categorize this product automatically? You can review the suggestion before applying it.', 'Admin')
            : stringFormat(
                  T._('Do you want to categorize these {0} products automatically? You can review every suggestion before applying it.', 'Admin'),
                  String(products.length)
              );

    return (
        <QuestionDialog
            message={message}
            onYesClick={() => {
                navigate(backofficeUrl('/products/categorize-ai'), { state: { products } });
                onClose();
            }}
        />
    );
};
